/**
 * @Description 分享页 租户logo + location logo
 */

import { FC, useEffect, useState } from 'react';
import IconFont from '@/common/components/IconFont';
import { useMethods } from '@lhb/hook';
import { getModelClusterModelConfig } from '@/common/api/networkplan';
import { isNotEmpty } from '@lhb/func';
import styles from './index.module.less';
import cs from 'classnames';

const ReportLogo: FC<any> = ({
  tenantId,
  tenantLogo, // 租户配置的报告上用logo
  className = '',
}) => {
  const [isHideLocationLogo, setIsHideLocationLogo] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    tenantId && methods.loadModelConfig();
  }, [tenantId]);

  const methods = useMethods({
    loadModelConfig() {
      getModelClusterModelConfig({
        tenantId,
      }).then((res) => {
        isNotEmpty(res?.showLocationLogo) && setIsHideLocationLogo(!res?.showLocationLogo);
      }).finally(() => {
        setLoaded(true);
      });
    },
  });

  return loaded ? (
    <div className={cs(styles.contentWrapper, className)}>
      <div className={styles.content}>
        {
          isHideLocationLogo ? <></> : <div className={styles.locationLogoWrapper}>
            <IconFont iconHref={'iconic_logo_pc'} className={styles.logoIcon} />
          </div>
        }
        {
          tenantLogo && !isHideLocationLogo ? <IconFont iconHref='pc-common-icon-ic_closeone' className={styles.flag}/> : <></>
        }
        {
          tenantLogo ? <div className={styles.targetLogo}>
            <img src={tenantLogo}/>
          </div> : <></>
        }
      </div>
    </div>
  ) : <></>;
};

export default ReportLogo;
